import React from 'react';
import { motion } from 'framer-motion';
import AnimatedCounter from './AnimatedCounter';

const stats = [
  { value: 30, suffix: '+', label: 'Team Members' },
  { value: 7, suffix: '+', label: 'Nationalities' },
  { value: 14, suffix: '', label: 'Languages Spoken' },
];

const TeamStatsSection = () => (
  <motion.section
    className="py-12 "
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.4 }}
    transition={{ duration: 0.8, ease: 'easeOut' }}
  >
    <div className="max-w-4xl mx-auto px-4 md:mb-28">
      <h2 className="text-3xl md:text-4xl font-semibold text-center mb-12">
        A Diverse Team Driving Global<br />Talent Solutions
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
        {stats.map((stat, i) => (
          <div key={i}>
            <div className="text-4xl font-bold mb-2">
              <AnimatedCounter value={stat.value} />{stat.suffix}
            </div>
            <div className="text-lg text-gray-700">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  </motion.section>
);

export default TeamStatsSection; 